
























import { Component, Vue, Prop } from 'vue-property-decorator';
import TreeChild from './treeChild.vue';
import { Gateway, Sensor, Transceiver, TransceiversApi } from '@/api';
@Component({
	components: { TreeChild },
})
export default class treeview extends Vue {
	@Prop(Object)
	public transceiver?: Transceiver;

	private tree: any = null;

	private api = new TransceiversApi();

	public async created() {
		this.tree = await this.makeTree();
	}

	public async makeTree() {
		if (!this.transceiver?.id) return null;

		const { data } = await this.api.getTransceiverById(this.transceiver.id, {
			params: {
				include:
					'gateway,' +
					'productAccessories,' +
					'nodes.sensors,' +
					'nodes.sensors.owner.product,' +
					'nodes.sensors.vat.product,' +
					'nodes.sensors.tank.product,' +
					'sensors,' +
					'sensors.owner.product,' +
					'sensors.vat.product,' +
					'sensors.tank.product,',
			},
		});
		let transceiver = data as Transceiver;

		if (!transceiver) return null;
		return {
			name: { value: transceiver.serialNumber, tooltip: transceiver.imei },
			entity: transceiver,
			type: 'transceiver',
			route: { name: 'transceivers.view', params: { transceiverId: transceiver.id } },
			children: transceiver.sensors
				?.filter(sensor => sensor.nodeId == null)
				.map(sensor => ({
					name: { value: sensor.serialNumber, tooltip: sensor.uniqueId },
					entity: sensor,
					type: 'sensor',
					route: { name: 'sensors.view', params: { sensorId: sensor.id } },
				}))
				.concat(
					transceiver.productaccessories.length ?? 0 > 0
						? transceiver?.productaccessories.map(accessory => ({
								name: { value: accessory.serialNumber, tooltip: accessory.uniqueId },
								entity: accessory,
								type: 'accessory',
								route: { name: 'accessories.view', params: { accessoryId: accessory.id } },
						  }))
						: [],
				)
				.concat(
					transceiver.gateway
						? [
								<any>{
									name: {
										value: transceiver.gateway?.serialNumber,
										tooltip: transceiver.gateway?.uniqueId,
									},
									entity: transceiver.gateway,
									type: 'gateway',
									route: transceiver.gateway
										? { name: 'gateways.view', params: { gatewayId: transceiver.gateway.id } }
										: null,
									children: transceiver.nodes?.length
										? transceiver.nodes?.map(node => ({
												name: { value: node.serialNumber, tooltip: node.uniqueId },
												entity: node,
												type: 'node',
												route: { name: 'nodes.view', params: { nodeId: node.id } },
												children: node.sensors?.map(sensor => ({
													name: { value: sensor.serialNumber, tooltip: sensor.uniqueId },
													entity: sensor,
													type: 'sensor',
													route: { name: 'sensors.view', params: { sensorId: sensor.id } },
												})),
										  }))
										: [],
								},
						  ]
						: [],
				),
		};
	}
}
